import { View, Text, TouchableOpacity } from 'react-native';
import { useRouter } from 'expo-router';
import { useThemedStyles } from '../src/theme/useThemedStyles';
import type { Theme } from '../src/theme/types';

export default function NotFound() {
  const router = useRouter();
  const styles = useThemedStyles(createStyles);

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Page Not Found</Text>
      <TouchableOpacity
        style={styles.button}
        onPress={() => router.replace('/(tabs)/activities')}
        accessibilityLabel="Go to activities"
        accessibilityRole="button"
        testID="not-found.go-to-activities-button"
      >
        <Text style={styles.buttonText}>Go to Activities</Text>
      </TouchableOpacity>
    </View>
  );
}

const createStyles = (theme: Theme) => ({
  container: {
    flex: 1,
    justifyContent: 'center' as const,
    alignItems: 'center' as const,
    backgroundColor: theme.colors.bgSecondary,
    padding: 24,
  },
  title: {
    fontSize: 20,
    fontWeight: '700' as const,
    color: theme.colors.textSecondary,
    marginBottom: 16,
  },
  button: {
    backgroundColor: theme.colors.primary,
    paddingHorizontal: 24,
    paddingVertical: 12,
    borderRadius: 8,
  },
  buttonText: {
    color: theme.colors.textOnPrimary,
    fontWeight: '600' as const,
    fontSize: 15,
  },
});
